import { InvoiceStatus } from '@css-xp/graphtypes/src/generated-types-new';
import { differenceInDays, parseISO } from 'date-fns';

export const isDueDateOverdue = (status: string, paymentError: boolean, dueDate: string) => {
  if (status === InvoiceStatus.OPEN || status === InvoiceStatus.UNCOLLECTIBLE || paymentError) {
    if (differenceInDays(parseISO(new Date().toISOString()), parseISO(dueDate)) > 0) {
      return true;
    }
  }
  return false;
};
